<script setup lang="ts">
defineOptions({
  name: 'SSNField'
})

const model = defineModel<string | null>()

const onUpdate = (updatedSSN: string | null) => {
  if (updatedSSN) {
    model.value = updatedSSN.toUpperCase()
  } else {
    model.value = updatedSSN
  }
}
</script>

<template>
  <VTextField
    :label="$t('form.label.ssn')"
    autocomplete="off"
    :model-value="model"
    @update:model-value="onUpdate"
  />
</template>
